function shuffle(sourceArray) {
  for (var i = 0; i < sourceArray.length - 1; i++) {
      var j = i + Math.floor(Math.random() * (sourceArray.length - i));

      var temp = sourceArray[j];
      sourceArray[j] = sourceArray[i];
      sourceArray[i] = temp;
  }
  return sourceArray;
}


let data = [
  {q:"１日",a:"ついたち"},
  {q:"２日",a:"ふつか"},
  {q:"３日",a:"みっか"},
  {q:"４日",a:"よっか"},
  {q:"５日",a:"いつか"},
  {q:"６日",a:"むいか"},
  {q:"７日",a:"なのか"},
  {q:"８日",a:"ようか"},
  {q:"９日",a:"ここのか"},
  {q:"１０日",a:"とおか"},
  {q:"１４日",a:"じゅうよっか"},
  {q:"１６日",a:"じゅうろくにち"},
  {q:"１７日",a:"じゅうしちにち"},
  {q:"１９日",a:"じゅうくにち"},
  {q:"２０日",a:"はつか"},
  {q:"２１日",a:"にじゅういちにち"},
  {q:"２４日",a:"にじゅうよっか"},
  {q:"３１日",a:"さんじゅういちにち"},
];

const orig = [...data];

data = shuffle(data);
const intro = "I giorni del mese";

export {data,intro,orig};
